import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  padding: 72px 0;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  background-color: rgba(28, 31, 46, 0.5);\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  position: sticky;\n  bottom: 0;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  gap: 8px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  overflow: auto;\n  flex-grow: 1;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  h3 {\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 1.5;\n    letter-spacing: -0.2px;\n\n    em {\n      color: ",
        ";\n    }\n  }\n\n  p {\n    color: ",
        ";\n    font-size: 16px;\n    line-height: 1.5;\n    letter-spacing: -0.16px;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n  overflow-x: hidden;\n  height: 80vh;\n  width: 520px;\n  .active-tab-wrapper {\n    li {\n      width: 100%;\n\n      div {\n        line-height: 1.5;\n      }\n    }\n\n    .active {\n      .usable {\n        em {\n          color: ",
        ";\n        }\n      }\n\n      .unusable {\n        em {\n          color: ",
        ";\n        }\n      }\n    }\n  }\n  @media (max-width: 768px) {\n    width: unset;\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.5;\n  letter-spacing: -0.16px;\n  text-align: center;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  padding: 12px 0;\n\n  > div {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .activeTab {\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _tagged_template_literal([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.16px;\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  letter-spacing: -0.14px;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _tagged_template_literal([
        "\n  width: 44px;\n  height: 62px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n\n  img {\n    box-shadow: 3px 3px 12px 0px rgba(28, 31, 46, 0.06);\n    border-radius: 2px;\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ActiveTab } from "@/components/common/ActiveTab";
import FilledButton from "@/components/common/Button/FilledButton";
import Image from "@/components/common/Image";
import Modal from "@/components/modal/Modal";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import React, { useEffect, useMemo, useState } from "react";
import Sheet from "react-modal-sheet";
import styled from "styled-components";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { numberFormatter } from "@/lib/utils";
import { DEFAULT_BOOK_COVER } from "@/settings/constant";
import useHandoutProductStore from "src/store/relatedProduct";
export const AvailableRelatedProductsModal = (param)=>{
    let { isOpen , onClose , usePassConfirmed  } = param;
    const { isMobile  } = useWindowDimensions();
    //태블릿은 모달
    //모바일은 바텀시트
    if (!isMobile) return /*#__PURE__*/ _jsx(RelatedProductsPurchasedModalContainer, {
        open: isOpen,
        onClose: onClose,
        width: null,
        depth: 1007,
        children: /*#__PURE__*/ _jsx(AvailableRelatedProducts, {
            onClose: onClose,
            usePassConfirmed: usePassConfirmed
        })
    });
    return /*#__PURE__*/ _jsx(PassInfoSheet, {
        isOpen: isOpen,
        onClose: onClose,
        detent: "content-height",
        children: /*#__PURE__*/ _jsx(Sheet.Container, {
            children: /*#__PURE__*/ _jsx(Sheet.Content, {
                children: /*#__PURE__*/ _jsx(AvailableRelatedProducts, {
                    onClose: onClose,
                    usePassConfirmed: usePassConfirmed
                })
            })
        })
    });
};
const RelatedProductsPurchasedModalContainer = styled(Modal).withConfig({
    componentId: "sc-72fa8f1e-0"
})(_templateObject());
const PassInfoSheet = styled(Sheet).withConfig({
    componentId: "sc-72fa8f1e-1"
})(_templateObject1(), (props)=>!props.isOpen && "background-color: transparent;");
export const thumbWidth = 56;
const AvailableRelatedProducts = (param)=>{
    let { onClose , usePassConfirmed  } = param;
    const { updatePurchaseProductsInfo , currentProduct , membershipAvailable , hasAlreadyOwned  } = useHandoutProductStore((state)=>({
            updatePurchaseProductsInfo: state.updatePurchaseProductsInfo,
            currentProduct: state.currentProduct,
            membershipAvailable: state.membershipAvailable,
            hasAlreadyOwned: state.hasAlreadyOwned
        }));
    const usableProducts = useMemo(()=>{
        if (currentProduct && !hasAlreadyOwned) {
            //연관교재 + 현재 보고있는 교재
            return membershipAvailable.usable.concat([
                {
                    title: currentProduct.title,
                    price: currentProduct.price,
                    id: currentProduct.id.toString(),
                    author: currentProduct.author,
                    unit: "",
                    thumbImg: currentProduct.thumb_img,
                    previewImgs: null,
                    purchaseOptions: currentProduct.purchaseOptions,
                    downloadPrice: currentProduct.downloadPrice
                }
            ]);
        }
        return membershipAvailable.usable;
    }, [
        membershipAvailable,
        hasAlreadyOwned,
        currentProduct
    ]);
    const unUsableProducts = useMemo(()=>{
        if (currentProduct && hasAlreadyOwned) {
            return membershipAvailable.unusable.concat([
                {
                    title: currentProduct.title,
                    price: currentProduct.price,
                    id: currentProduct.id.toString(),
                    author: currentProduct.author,
                    unit: "",
                    thumbImg: currentProduct.thumb_img,
                    previewImgs: null,
                    purchaseOptions: currentProduct.purchaseOptions,
                    downloadPrice: currentProduct.downloadPrice
                }
            ]);
        }
        return membershipAvailable.unusable;
    }, [
        membershipAvailable,
        hasAlreadyOwned,
        currentProduct
    ]);
    const [currentTab, setCurrentTab] = useState("usable");
    const onChangeTab = (key)=>{
        setCurrentTab(key);
        mixpanelEvent("Tab UI Clicked", {
            "Tab Type": "Pass Availability",
            "Tab Name": key
        });
    };
    const onClick = ()=>{
        //선택교재 업데이트
        updatePurchaseProductsInfo({
            selectedRelatedProducts: membershipAvailable.usable,
            totalCount: membershipAvailable.usable.length + 1,
            totalPrice: membershipAvailable.usable.reduce((acc, cur)=>acc + cur.price, 0) + currentProduct.price
        });
        //이용권 사용하기
        onClose();
        usePassConfirmed();
        mixpanelEvent("Popup Button Clicked", {
            "Popup Type": "Pass Availability Confirmed",
            "Popup Title": "사용가능 자료 ".concat(usableProducts.length, "개에 이용권을 사용할까요?"),
            "Button Name": "".concat(usableProducts.length, "회 사용하기"),
            "Button URL": null
        });
    };
    const noUsableProducts = useMemo(()=>usableProducts.length === 0, [
        usableProducts
    ]);
    const tabList = [
        {
            key: "usable",
            label: /*#__PURE__*/ _jsxs(TabItem, {
                className: "usable",
                children: [
                    "사용가능 자료 ",
                    /*#__PURE__*/ _jsxs("em", {
                        children: [
                            usableProducts.length,
                            "개"
                        ]
                    })
                ]
            })
        },
        {
            key: "unusable",
            label: /*#__PURE__*/ _jsxs(TabItem, {
                className: "unusable",
                children: [
                    "사용불가 자료 ",
                    /*#__PURE__*/ _jsxs("em", {
                        children: [
                            unUsableProducts.length,
                            "개"
                        ]
                    })
                ]
            })
        }
    ];
    useEffect(()=>{
        mixpanelEvent("Pass Availability Popup Viewed", {
            "Product IDs": usableProducts.map((product)=>product.id).concat(currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.id.toString()),
            "Product Titles": usableProducts.map((product)=>product.title).concat(currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.title),
            "Pass Availability": "Y"
        });
        mixpanelEvent("Pass Availability Popup Viewed", {
            "Product IDs": unUsableProducts.map((product)=>product.id),
            "Product Titles": unUsableProducts.map((product)=>product.title),
            "Pass Availability": "N"
        });
    }, []);
    useEffect(()=>{
        if (noUsableProducts) {
            setCurrentTab("unusable");
        }
    }, [
        noUsableProducts
    ]);
    return /*#__PURE__*/ _jsxs(RelatedProductsPurchasedContainer, {
        children: [
            /*#__PURE__*/ _jsxs(Header, {
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        children: noUsableProducts ? "선택하신 자료들은 이용권을 사용할 수 없어요." : /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                "사용가능 자료 ",
                                /*#__PURE__*/ _jsxs("em", {
                                    children: [
                                        usableProducts.length,
                                        "개"
                                    ]
                                }),
                                "에 이용권을 사용할까요?"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: noUsableProducts ? "이미 구매한 자료이거나 이용권 사용 조건에 맞지 않아요." : /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                "선택한 이용권에 맞지 않는 자료가 있어요. ",
                                /*#__PURE__*/ _jsx("br", {}),
                                "아래 리스트에서 자료를 확인 후 이용권 사용하기를 눌러주세요."
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ActiveTab, {
                activeTab: currentTab,
                setActiveTab: onChangeTab,
                tabList: tabList
            }),
            /*#__PURE__*/ _jsx(ProductListLayout, {
                children: currentTab === "unusable" ? unUsableProducts.map((product, idx)=>/*#__PURE__*/ _jsx(RelatedProductItem, {
                        currentProduct: currentProduct,
                        hasAlreadyOwned: hasAlreadyOwned,
                        product: product
                    }, "unusable" + idx)) : usableProducts.map((product, idx)=>/*#__PURE__*/ _jsx(RelatedProductItem, {
                        product: product
                    }, "usable" + idx))
            }),
            /*#__PURE__*/ _jsx(Footer, {
                children: noUsableProducts ? /*#__PURE__*/ _jsx(FilledButton, {
                    type: "text",
                    variant: "solid",
                    onClick: onClose,
                    children: "닫기"
                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(FilledButton, {
                            type: "text",
                            variant: "soft",
                            onClick: ()=>{
                                onClose();
                                mixpanelEvent("Popup Button Clicked", {
                                    "Popup Type": "Pass Availability Confirmed",
                                    "Popup Title": "사용가능 자료 ".concat(usableProducts.length, "개에 이용권을 사용할까요?"),
                                    "Button Name": "닫기",
                                    "Button URL": null
                                });
                            },
                            children: "닫기"
                        }),
                        /*#__PURE__*/ _jsxs(FilledButton, {
                            type: "text",
                            variant: "solid",
                            onClick: onClick,
                            children: [
                                usableProducts.length,
                                "회 사용하기"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const Footer = styled.div.withConfig({
    componentId: "sc-72fa8f1e-2"
})(_templateObject2());
const ProductListLayout = styled.div.withConfig({
    componentId: "sc-72fa8f1e-3"
})(_templateObject3());
const Header = styled.div.withConfig({
    componentId: "sc-72fa8f1e-4"
})(_templateObject4(), (props)=>props.theme.new.colors.sol_blue_500, (props)=>props.theme.new.colors.sol_gray_700);
const RelatedProductsPurchasedContainer = styled.div.withConfig({
    componentId: "sc-72fa8f1e-5"
})(_templateObject5(), (props)=>props.theme.new.colors.sol_blue_500, (props)=>props.theme.new.colors.sol_red_500);
const TabItem = styled.div.withConfig({
    componentId: "sc-72fa8f1e-6"
})(_templateObject6());
const RelatedProductItem = (param)=>{
    let { product , hasAlreadyOwned , currentProduct  } = param;
    const isCurrentProduct = useMemo(()=>{
        return (currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.id.toString()) === product.id;
    }, [
        currentProduct,
        product
    ]);
    return /*#__PURE__*/ _jsxs(RelatedProductItemContainer, {
        children: [
            /*#__PURE__*/ _jsx(ImageContainer, {
                children: /*#__PURE__*/ _jsx(Image, {
                    src: product.thumbImg || DEFAULT_BOOK_COVER,
                    alt: product.title,
                    width: 44,
                    height: 62
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(Title, {
                        children: product.title
                    }),
                    hasAlreadyOwned && isCurrentProduct ? /*#__PURE__*/ _jsx(Price, {
                        children: "이미 구입한 자료"
                    }) : /*#__PURE__*/ _jsxs(Price, {
                        children: [
                            numberFormatter(product.price),
                            "원"
                        ]
                    })
                ]
            })
        ]
    });
};
const RelatedProductItemContainer = styled.div.withConfig({
    componentId: "sc-72fa8f1e-7"
})(_templateObject7());
const Title = styled.p.withConfig({
    componentId: "sc-72fa8f1e-8"
})(_templateObject8());
const Price = styled.p.withConfig({
    componentId: "sc-72fa8f1e-9"
})(_templateObject9(), (props)=>props.theme.new.colors.sol_gray_500);
const ImageContainer = styled.div.withConfig({
    componentId: "sc-72fa8f1e-10"
})(_templateObject10());
